import { stringValidator } from '#validation/common/validators';
import { BUCKET_MAX_LENGTH, BUCKET_MIN_LENGTH, BUCKET_NAME_CONTENT_REGEX, BUCKET_NAME_DASHES_REGEX, BUCKET_NAME_ENDS_WITH_REGEX, BUCKET_NAME_START_WITH_REGEX, } from '../constants';
export const storageBucketValidator = stringValidator({
    minLength: {
        min: BUCKET_MIN_LENGTH,
        error: 'filespace.storageBucket.minLength',
    },
    maxLength: {
        max: BUCKET_MAX_LENGTH,
        error: 'filespace.storageBucket.maxLength',
    },
    formats: [
        {
            regex: BUCKET_NAME_START_WITH_REGEX,
            error: 'filespace.storageBucket.startsWith',
        },
        {
            regex: BUCKET_NAME_ENDS_WITH_REGEX,
            error: 'filespace.storageBucket.endsWith',
        },
        {
            regex: BUCKET_NAME_CONTENT_REGEX,
            error: 'filespace.storageBucket.invalidChar',
        },
        {
            regex: BUCKET_NAME_DASHES_REGEX,
            error: 'filespace.storageBucket.dashes',
        },
    ],
});
